import { render } from "./Notice.vue?vue&type=template&id=1de36bc4&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"

import "./Notice.vue?vue&type=style&index=0&id=1de36bc4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1de36bc4"

export default script